/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, shape, array, string,
} from 'prop-types';
import { useSelector } from 'react-redux';
import PageHeading from './PageHeading';
import CallOrderDetail from './CallOrderDetail';
import TrendingProducts from './TrendingProducts';
import ShopByCountry from './ShopByCountry';
import customBreakpoints from '../../../helpers/customBreakpoints';
import { getOperatingSystem } from '../../../../state/ducks/App/ducks/Config/Config-Helpers';
import { getCurrentBrandId } from '../../../pages/Account/utils/featureSelectors';
import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';

const styles = (theme) => ({
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downSmall,
            margin: '0 auto',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers.container.maxWidth.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: '1440px',
            margin: '0 auto',
        },
    },
    headingBlock: {
        display: 'flex',
        alignItems: 'flex-start',
        background: '#E9FDE8',
        borderBottom: 'thin solid #999',
        padding: '1% 4%',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            display: 'block',
        },
    },
    headingTitle: {
        fontSize: '45px',
        margin: '22px 0px',
        letterSpacing: '0.03em',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: '26px',
        },
    },

    headingSubTitle: {
        width: '80%',
        fontSize: '14px',
        letterSpacing: '0.03em',
        lineHeight: '20px',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            width: '100%',
        },
    },
    listBlock: {
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            marginLeft: '1rem',
            marginTop: '1rem',
            marginBottom: '1rem',
        },
    },
    listItem: {
        fontSize: '16px',
        fontWeight: 'bold',
        lineHeight: '19px',
        letterSpacing: '0.03em',

    },
    callInfo: {
        display: 'flex',
        fontSize: '16px',
        padding: '1% 4%',
        borderBottom: 'thin solid #999',
        width: '100%',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            display: 'block',
        },

    },
    orderByCallTitle: {
        fontWeight: 'bold',
        marginBottom: '15px',
        marginTop: '0',
    },
    orderByPhone: {
        width: '100%',
        flexBasis: '100%',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            marginBottom: '10px',
            flexBasis: '100%',
        },
    },
    callNumberDetail: {
        display: 'flex',
        flexWrap: 'wrap',
        fontSize: '15px',
        letterSpacing: '0.03em',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            justifyContent: 'space-evenly',
        },
        '& ul': {
            margin: 0,
            padding: 0,
            listStyle: 'none',

        },
    },
    callFlexBasis: {
        flexBasis: '50%',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            marginBottom: '10px',
            flexBasis: '100%',
        },
    },
    callByTitle: {
        lineHeight: '22px',
    },
    trendingProducts: {
        marginTop: '20px',
        textAlign: 'center',
        '& ul': {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            padding: '0 3px',
            [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
                justifyContent: 'space-evenly',
                padding: '0px',
            },
        },

    },
    trendingProductHeading: {
        fontSize: '36px',
        lineHeight: '36px',
        textTransform: 'uppercase',
        fontWeight: 'bold',
        margin: '0',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            fontSize: '18px',
        },
    },
    trendingList: {
        flexBasis: 'auto',
        padding: '0 15px',
        marginBottom: '20px',
        listStyle: 'none',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            flexBasis: '50%',
        },
    },
    trendingProductLink: {
        textDecoration: 'none',
    },
    trendingProductImage: {
        display: 'block',
        position: 'relative',
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: 'transparent',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            width: '100%',
        },
    },
    trendingProductTitle: {
        textTransform: 'uppercase',
        margin: '10px 0',
        color: '#666',
        fontSize: '17px',
    },
    trendingProductFlag: {
        margin: '0 auto',
    },
    disclaimerText: {
        margin: '20px 0',
        fontSize: '17px',
        textAlign: 'center',
        padding: '20px 0',
        borderTop: 'solid thin #999999',
        borderBottom: 'solid thin #999999',
        backgroundColor: '#fbf8ff',
        [theme.breakpoints.down(customBreakpoints.tabLandscape)]: {
            padding: '20px',
        },
    },

});

const InternationalFlowerDeliveryBlock = ({
    data,
    classes,
}) => {
    const {
        header_data: {
            title, title_color, list_item, sub_title,
        },
        order_call_detial: {
            order_call_title,
            list_call,
            tips,
        },
        trending_products: {
            trending_title,
            product_lists,
            disclaimer_text,
        },
        shop_by_country: {
            heading,
            shop_link,
            countries,
        },
    } = data;
    const operatingSystem = getOperatingSystem().toLowerCase();
    const currentBrand = useSelector((state) => getCurrentBrandId(state));
    const featureFlags = useSelector((state) => getFeatureFlags(state));
    const customerData = useSelector((state) => state?.member);
    const chatLinkStyle = {
        marginLeft: '3px',
        marginRight: '3px',
        ...(operatingSystem !== 'android' && { textDecoration: 'underline', cursor: 'pointer' }),
    };
    return (
        <>
            <PageHeading
                headingTitle={title}
                titleFontColor={title_color}
                subTitle={sub_title}
                listItem={list_item}
                classes={classes}

            />
            <CallOrderDetail
                orderCallTitle={order_call_title}
                listCall={list_call}
                tips={tips}
                classes={classes}
                operatingSystem={operatingSystem}
                currentBrand={currentBrand}
                featureFlags={featureFlags}
                customerData={customerData}
                chatLinkStyle={chatLinkStyle}
            />
            <TrendingProducts
                trendingTitle={trending_title}
                productLists={product_lists}
                disclaimerText={disclaimer_text}
                classes={classes}
            />
            <ShopByCountry
                heading={heading}
                shopLink={shop_link}
                countries={countries}
                styleCSS={classes}
                operatingSystem={operatingSystem}
                currentBrand={currentBrand}
                featureFlags={featureFlags}
                customerData={customerData}
                chatLinkStyle={chatLinkStyle}
            />
        </>
    );
};

InternationalFlowerDeliveryBlock.propTypes = {
    classes: object.isRequired,
    data: shape({
        header_data: shape({
            title: string.isRequired,
            title_color: string.isRequired,
            sub_title: string.isRequired,
            list_item: array.isRequired,
        }),
        order_call_detial: shape({
            order_call_title: string.isRequired,
            list_call: array.isRequired,
            tips: object.isRequired,
        }),
        trending_products: shape({
            trending_title: string.isRequired,
            product_lists: array.isRequired,
            disclaimer_text: string.isRequired,
        }),
        shop_by_country: shape({
            heading: string.isRequired,
            shop_link: array.isRequired,
            countries: object.isRequired,
        }),
    }).isRequired,
};
export default withStyles(styles)(InternationalFlowerDeliveryBlock);
